export const DROPDOWN = {
    'os' : [{label: 'Select', value: ''}, {label: 'Android', value: 'android'},
            {label: 'IOS', value: 'ios'}, {label: 'Mac OS X', value: 'macosx'}, {label: 'Ubuntu', value: 'ubuntu'},
            {label: 'Windows', value: 'windows'}],
    'ctn': [{label: 'Select', value: ''}]

};
